import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, Loading, ToastController, LoadingController, AlertController, ActionSheetController, PopoverController } from 'ionic-angular';
import { UserAddAdminPage } from '../../pages/user-add-admin/user-add-admin';
import { UserUpdateAdminPage } from '../../pages/user-update-admin/user-update-admin';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { WhereFilterOp } from '@firebase/firestore-types';
import { AdminProvider } from '../../providers/admin/admin';
import moment from 'moment';
import { Subscription } from 'rxjs/Subscription';

interface myInterface {
  dob: number;
  calendar: [{
    complete: boolean;
    date: Date;
    fileReq: boolean;
    files: [{
      fullPath: string;
      name: string;
      path: string;
    }];
    notes: string;
    task: boolean;
    topic: string;
  }];
  internalComments: Array<string>;
  company: string;
  name: string;
  lastName: string;
  ocupation: string;
  sex: string;
  id: string;
  status: number;
}

@Component({
  selector: 'users-admin',
  templateUrl: 'users-admin.html'
})
export class UsersAdminComponent {
  @Input() destroy: boolean;
  @Output() destroyReturn: EventEmitter<any> = new EventEmitter<boolean>();
  activeTab = 0;
  itemSel: any;
  itemsCollection: AngularFirestoreCollection<myInterface>;
  //itemsCollection2: AngularFirestoreCollection<myInterface>;
  usuarios: myInterface[] = [];
 // usuarios2: myInterface[] = [];
  coaches: myInterface[];
  admins: myInterface[];
  userCalculator: myInterface[];
  loading: Loading;
  calendarSessions: any;
  subscriptions: Subscription[] = [];
  //lastVisible: any;
  buttonLoad: boolean = true;

  constructor(public admin: AdminProvider, public afAuth: AngularFireAuth, public asf: AngularFirestore, public modalCtrl: ModalController, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController, public popoverCtrl: PopoverController) { }

  ngOnInit() {
    this.init();
  }

  init() {
    // Usuarios
    this.itemsCollection = this.asf.collection("Users", ref => ref.where("type", "==", 2).orderBy("uppercaseName", "asc"));
    this.itemsCollection.snapshotChanges().subscribe((documentSnapshots) => {
      // this.lastVisible = documentSnapshots[documentSnapshots.length - 1].payload.doc;
      this.usuarios = documentSnapshots.map((item) => {
        const data = item.payload.doc.data() as myInterface;
        const id = item.payload.doc.id;
        return { id, ...data }
      });
    });
    //Administradores
    this.itemsCollection = this.asf.collection("Users", ref => ref.where("type", "==", 1).orderBy("uppercaseName", "asc"));
    this.itemsCollection.snapshotChanges().subscribe((data) => {
      this.admins = data.map((item) => {
        const data = item.payload.doc.data() as myInterface;
        const id = item.payload.doc.id;
        return { id, ...data }
      });
    });
  }

  changeActiveTab(x) {
    if (this.activeTab == x) {
      this.activeTab = 0
    } else {
      this.activeTab = x;
    }
  }

  selectItem(x) {
    this.itemSel = x;
    this.changeActiveTab(this.activeTab);
  }

  presentAddModal() {
    let addModal = this.modalCtrl.create(UserAddAdminPage);
    addModal.present();
  }

  presentConfirmDelete(id: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar usuario',
      message: '¿Estas seguro de eliminar usuario?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id);
          }
        }
      ]
    });
    alert.present();
  }

  async deleteDb(idDocument) {
    const promise1: Promise<any> = this.deleteWhere("Sessions", "idAlumno", "==", idDocument);
    const promise2: Promise<any> = this.deleteWhere("Tasks", "idAlumno", "==", idDocument);
    const promise3: Promise<any> = this.asf.doc("Users/" + idDocument).delete();
    await Promise.all([promise1, promise2, promise3]);
  }

  deleteItem(idDocument: string) {
    this.presentLoadingCustom();
    this.afAuth.auth.currentUser.getIdToken(true).then((idToken) => {
      this.admin.deleteAccount(idToken, idDocument).toPromise().then((response) => {
        if (response['success'] == true) {
          this.deleteDb(idDocument).then(() => {
            this.loading.dismiss();
            this.presentToast('Eliminado correctamente');
          }).catch(error => {
            this.loading.dismiss();
            ////console.error(error);
            this.presentToast('Ha ocurrido un error');
          });
        } else {
          this.loading.dismiss();
          ////console.error(response);
          this.presentToast('Ha ocurrido un error');
        }
      }).catch(error => {
        this.loading.dismiss();
        ////console.error(error);
        this.presentToast('Ha ocurrido un error');
      });
    }).catch(error => {
      this.loading.dismiss();
      ////console.error(error);
      this.presentToast('Ha ocurrido un error');
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  async deleteWhere(collection: string, field: string, operator: WhereFilterOp, value: any) {
    let query = this.asf.collection(collection).ref.where(field, operator, value).get();
    let batch = this.asf.firestore.batch();
    await query.then(async data => {
      data.docs.forEach(element => {
        batch.delete(element.ref);
      });
      await batch.commit();
    });
  }

  updateItem(item: any) {
    let modal = this.modalCtrl.create(UserUpdateAdminPage, { "item": item });
    modal.present();
  }

  stringDate(date: any): string {
    moment.locale("es");
    return moment(date).format("lll");
  }

  presentActionSheet(item: any) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Usuario',
      buttons: [
        {
          text: 'Eliminar',
          role: 'destructive',
          handler: () => {
            this.presentConfirmDelete(item.id);
          }
        }, {
          text: 'Modificar',
          handler: () => {
            this.updateItem(item);
          }
        }, {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            ////console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/users-admin/users-admin.ts